import styled from 'styled-components'
import { CodeBlock as RawCodeBlock, Line } from '../../components'

export const CodeBlock = styled(RawCodeBlock)`
  ${Line} {
    display: inline-block;
  }
`
